import {   GET_ALL_CUSTOMER_TYPE_ACTIVE_REQUEST,
	GET_ALL_CUSTOMER_TYPE_ACTIVE_SUCCESS,
	GET_ALL_CUSTOMER_TYPE_ACTIVE_ERROR, } from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_ALL_CUSTOMER_TYPE_ACTIVE_REQUEST:
			return {
				loading: true,
			};
		case GET_ALL_CUSTOMER_TYPE_ACTIVE_SUCCESS:
			return {
				...state,
				loading: false,
				payload
						};
		case GET_ALL_CUSTOMER_TYPE_ACTIVE_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};

		default:
			return state;
	}
}
